"use client";
import React from "react";
import PropTypes from "prop-types";
import cn from "classnames";

import useWindowDimensions from "@/next-src/hooks/useWindowDimensions";
import convertHTMLtoJSX from "@/next-src/utils/convertHTMLtoJSX";

import comCSS from "./LongevityPrograms.module.scss";
import Card from "./card/Card";

const LongevityPrograms = ({ className = "", data }) => {
  const { width: windowWidth } = useWindowDimensions();

  const {
    preTitleMobile,
    titleMobile,
    textMobile,
    cards,
    bgColorMobile,
    paddingTopMobile,
    paddingBottomMobile,
  } = data || {};

  let { preTitle, title, text, bgColor, paddingTop, paddingBottom } =
    data || {};

  if (windowWidth < 992) {
    preTitle = preTitleMobile;
    title = titleMobile;
    text = textMobile;
    bgColor = bgColorMobile;
    paddingTop = paddingTopMobile;
    paddingBottom = paddingBottomMobile;
  }

  return (
    <section
      className={cn(
        className,
        comCSS.wrapper,
        "section background-color-soft-blue padding-section-large"
      )}
      style={{
        backgroundColor: bgColor,
        paddingTop:
          paddingTop !== null && paddingTop >= 0 ? `${paddingTop}px` : "",
        paddingBottom:
          paddingBottom !== null && paddingBottom >= 0
            ? `${paddingBottom}px`
            : "",
      }}
    >
      <div className="padding-global">
        <div className="container-large">
          <div className=" add-line-top">
            <div className="margin-bottom margin-xlarge">
              <div className="text-align-center">
                <div className="center_component">
                  <div className="max-width-xlarge">
                    <div className="margin-bottom margin-xsmall">
                      <div className="text-note">
                        {convertHTMLtoJSX(preTitle)}
                      </div>
                    </div>
                    <div className="margin-bottom margin-small">
                      {convertHTMLtoJSX(title)}
                    </div>
                  </div>
                  <div className="max-width-small">
                    {convertHTMLtoJSX(text)}
                  </div>
                </div>
              </div>
            </div>
            <div className="w-layout-grid programs-horizontal-list">
              <div className="programs-horizontal-inner-wrap">
                {cards
                  ?.filter((el) => !el.hide)
                  ?.map((el, i) => (
                    <Card
                      key={el.id}
                      data={el}
                      index={i}
                      isLast={cards?.length - 1 === i}
                    />
                  ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

LongevityPrograms.propTypes = {
  className: PropTypes.string,
  data: PropTypes.shape({
    preTitle: PropTypes.string,
    preTitleMobile: PropTypes.string,
    title: PropTypes.string,
    titleMobile: PropTypes.string,
    text: PropTypes.string,
    cards: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string,
        title: PropTypes.string,
        titleMobile: PropTypes.string,
        text: PropTypes.string,
        textMobile: PropTypes.string,
        image: PropTypes.shape({
          id: PropTypes.string,
          src: PropTypes.string,
          alt: PropTypes.string,
        }),
        button: PropTypes.shape({
          id: PropTypes.string,
          text: PropTypes.string,
          url: PropTypes.string,
          bgColor: PropTypes.string,
          bgColorHover: PropTypes.string,
          borderColor: PropTypes.string,
          borderColorHover: PropTypes.string,
          hide: PropTypes.bool,
        }),
        buttonMobile: PropTypes.shape({
          id: PropTypes.string,
          text: PropTypes.string,
          url: PropTypes.string,
          bgColor: PropTypes.string,
          bgColorHover: PropTypes.string,
          borderColor: PropTypes.string,
          borderColorHover: PropTypes.string,
          hide: PropTypes.bool,
        }),
        secondButton: PropTypes.shape({
          id: PropTypes.string,
          text: PropTypes.string,
          url: PropTypes.string,
          bgColor: PropTypes.string,
          bgColorHover: PropTypes.string,
          borderColor: PropTypes.string,
          borderColorHover: PropTypes.string,
          hide: PropTypes.bool,
        }),
        secondButtonMobile: PropTypes.shape({
          id: PropTypes.string,
          text: PropTypes.string,
          url: PropTypes.string,
          bgColor: PropTypes.string,
          bgColorHover: PropTypes.string,
          borderColor: PropTypes.string,
          borderColorHover: PropTypes.string,
          hide: PropTypes.bool,
        }),
        calendlyButtonSuccess: PropTypes.shape({
          id: PropTypes.string,
          text: PropTypes.string,
          url: PropTypes.string,
          bgColor: PropTypes.string,
          bgColorHover: PropTypes.string,
          borderColor: PropTypes.string,
          borderColorHover: PropTypes.string,
          hide: PropTypes.bool,
        }),
        calendlyButtonSuccessMobile: PropTypes.shape({
          id: PropTypes.string,
          text: PropTypes.string,
          url: PropTypes.string,
          bgColor: PropTypes.string,
          bgColorHover: PropTypes.string,
          borderColor: PropTypes.string,
          borderColorHover: PropTypes.string,
          hide: PropTypes.bool,
        }),
        hide: PropTypes.bool,
      })
    ),
    paddingTop: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    paddingBottom: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    paddingTopMobile: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    paddingBottomMobile: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
    ]),
    bgColor: PropTypes.string,
    bgColorMobile: PropTypes.string,
  }),
};

export default LongevityPrograms;
